module.exports = "/_next/static/images/OrchestrateJourneys-a0eb8431ef6a619095a43c2a2f8091e3.webp";